import { render, staticRenderFns } from "./DappSubmissionLayout.vue?vue&type=template&id=5ea80386&scoped=true&"
import script from "./DappSubmissionLayout.vue?vue&type=script&lang=js&"
export * from "./DappSubmissionLayout.vue?vue&type=script&lang=js&"
import style0 from "./DappSubmissionLayout.vue?vue&type=style&index=0&id=5ea80386&lang=scss&scoped=true&"
import style1 from "./DappSubmissionLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea80386",
  null
  
)

export default component.exports